import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import { EventCode } from "../../data/enums/eventCode";
import { OperationRequestData } from "../../data/operationRequestData";
import { OperationModel } from "../operations/operationModel";
import i18n from "@/i18n";

/** Модель фосстановления доступа */
export class RecoveryModel extends OperationModel {
  /**Номер договора, счета или карты*/
  public AccountNumber: string = "";

  /**Логин*/
  public Login: string = "";

  /**Номер телефона */
  public Phone: string = "";

  /**Правила заполнения номера телефона */
  public PhoneRules: Array<Function> = [
    (p: any) => !!p || i18n.t("auth.errors.phoneEmpty"),
    (p: any) =>
      (p && /^\+7\([0-9]{3}\)[0-9]{3}-[0-9]{2}-[0-9]{2}$/.test(p)) ||
      i18n.t("auth.errors.phoneCheck")
  ];

  /**Правила заполнения номера карты/счета */
  public AccountNumberRules: Array<any> = [
    (l: any) => !!l || i18n.t("auth.errors.accountNumberCheck")
  ];

  /**Маска телефона*/
  public PhoneMask: string = '+7(###)###-##-##';

  /**Серия и номер документа */
  public Passport: string = "";

  /**Способ восстановления  password | login*/
  public RecoveryMode: string = "password";

  public readonly PasswordMode: string = "password";

  public readonly LoginMode: string = "login";

  /**Код операции восстановления пароля */
  public PasswordRecRespondentCode: string = "RecoveryPassword";

  /**Код операции восстановления логина */
  public LoginRecRespondentCode: string = "RecoveryLogin";

  /**Текст после успешного исполнения */
  public SuccessMessage: string = "";

  constructor() {
    super();
  }

  /**
   * Создание запроса операции.
   */
  public createOperationRequest(): OperationRequestData {
    const ord = new OperationRequestData();
    const isLoginMode: boolean = this.RecoveryMode == this.LoginMode;
    ord.respondentCode = isLoginMode ?  this.LoginRecRespondentCode : this.PasswordRecRespondentCode;
    ord.operationId = this.OperationId;
    ord.EventCode = isLoginMode ? EventCode.ResetLogin : EventCode.ResetPassword;

    ord.setProperty("login", !isLoginMode ? this.Login : "", DeclarationPropertiesTypes.String);
    ord.setProperty("phone", this.Phone.replace(/\s|\(|\)|\-/g, ""), DeclarationPropertiesTypes.String);
    ord.setProperty("passport", this.Passport.replace(/\s/g, ""), DeclarationPropertiesTypes.String);
    ord.setProperty("number", this.AccountNumber.replace(/\s/g, ""), DeclarationPropertiesTypes.String);

    return ord;
  }

  
  /**
   * Заполнение операции данными из ответа запроса.
   * @param ord Данные запроса.
   * @param bAssign Признак assign.
   */
   public setOperationFromRequest(ord: OperationRequestData): void {
    this.SuccessMessage = i18n.t(`auth.messages.successrecovery${this.RecoveryMode}`).toString(); 
  }

  
}
